/**
 * 工具函数 - 临时copy来的
 * !!!请看这里
 * 使用下列命令来擦除类型
 * ```bash
 *  tsc -t esnext func.ts
 * ```
 * 输出至 func.js
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-06-28 10:05:25
 */
// import { TNode, Tree } from '@/type/advanced';
// import { cityArray } from '@/util/city';
/**
 * 根据行政编码生成具体的省市县名称
 * @author 棠棣
 * @since  2020-06-22 10:33:00
 */
// export const getAddressName = (provance: number, city: number, region: number) => {
//   if (provance) {
//     for (let i = 0; i < cityArray.length; i++) {
//       if (cityArray[i].value === provance) {
//         if (city) {
//           for (let j = 0; j < cityArray[i].children.length; j++) {
//             if (region) {
//               for (let k = 0; k < cityArray[i].children[j].children.length; k++) {
//                 if (cityArray[i].children[j].children[k].value === region) {
//                   return (
//                     cityArray[i].label +
//                     cityArray[i].children[j].label +
//                     cityArray[i].children[j].children[k].label
//                   );
//                 }
//               }
//             } else {
//               return cityArray[i].label + cityArray[i].children[j].label;
//             }
//           }
//         } else {
//           return cityArray[i].label;
//         }
//       }
//     }
//   }
// };
/**
 * 将Vue响应式对象转换成一个新的干净的对象
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-06-12 09:23:29
 * @param {any} obj 待转换的Vue响应式对象
 * @return {any} cleanObj 干净的对象
 */
export const getCleanObjFromVue = (obj) => JSON.parse(JSON.stringify(obj));
/**
 * 计算以给定二维数组第一维元素为因子的笛卡尔积
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-06-15 15:25:40
 */
export const TowDArray2CartesianProduct = (arr) => {
    if (arr.length === 1) {
        return arr[0].map(el => [el]);
    }
    const ret = arr.reduce((acc, cur) => {
        if (acc.length === 0) {
            return cur.map(curEl => [curEl]);
        }
        const res = [];
        acc.forEach((accEl) => {
            cur.forEach((curEl) => {
                const accArr = Array.isArray(accEl) ? accEl : [accEl];
                res.push([...accArr, curEl]);
            });
        });
        return res;
    }, []);
    return ret;
};
// date/time
/**
 * 简单的日期时间格式化，根据商品列表UI来的
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-06-18 11:17:47
 */
export const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return ([date.getFullYear(), date.getMonth() + 1, date.getDate()]
        .map(el => `${el}`.padStart(2, '0'))
        .join('.') +
        ' ' +
        [date.getHours(), date.getMinutes(), date.getSeconds()]
            .map(el => `${el}`.padStart(2, '0'))
            .join(':'));
};
/**
 * 判断是否空数组
 * @param {any} val
 * @return {boolean}
 */
export const isEmptyArray = (val) => Array.isArray(val) && val.length === 0;
/**
 * 判断是否对象(非数组)
 * @param {any} val
 * @return {boolean}
 */
export const isObject = (val) => typeof val === 'object' && !Array.isArray(val);
/**
 * 判断是否空对象(非数组)
 * @param {any} val
 * @return {boolean}
 */
export const isEmptyObject = (val) => isObject(val) && Object.keys(val).length === 0;
/**
 * 判断变量是否为空值
 * 空字符串、空数组、空对象、undefined、null 均判定为空值
 */
export const isEmpty = (val) => typeof val === 'number'
    ? false
    : val === '' || val === undefined || val === null || isEmptyArray(val) || isEmptyObject(val);
/**
 * 类似 Array.prototype.map 的方式
 * 将一个非数组对象进行映射到新的对象
 * @param {object} obj 待转换的对象
 * @param fn 映射函数
 * @return {object} newObj 新的对象
 *
 * ```
 *  const obj = { a: 1, b: 2 };
 *  const newObj = ObjectMap(obj, ([ key, val ]) => ([ key, val * 2 ]));
 *  // Result: { a: 2, b: 4 }
 * ```
 */
export const ObjectMap = (obj, fn) => Object.fromEntries(Object.entries(obj).map(fn));
/**
 * 类似 Array.prototype.filter 的方式
 * 将一个非数组对象的特定键值对过滤掉
 * @param {object} obj 待转换的对象
 * @param fn 过滤函数
 * @return {object} newObj 新的对象
 */
export const ObjectFilter = (obj, fn) => Object.fromEntries(Object.entries(obj).filter(fn));
/**
 * 过滤掉对象中空值
 * 返回新对象
 * @param {any} obj
 * @return {any} newObj
 */
export const ObjectFilterEmpty = (obj) => ObjectFilter(obj, element => !isEmpty(element[1]));
/**
 * 扁平数组转树
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-06-20 17:13:28
 */
// export function toTree<T extends TNode = TNode>(flatArray: T[], pid = 0): Tree<T>[] {
//   const tree: Tree<T>[] = flatArray
//     .filter(node => node.pid === pid)
//     .map(node => {
//       const children: Tree<T>[] = [];
//       return {
//         ...node,
//         children,
//       };
//     });
//   const leftNode = flatArray.filter(node => node.pid !== pid);
//   if (leftNode.length > 0) {
//     tree.forEach(node => {
//       node.children = [...(node.children ?? []), ...toTree(leftNode, node.id)];
//     });
//   }
//   return tree;
// }
/**
 * key -> value object 转 url search params
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-06-23 14:16:16
 */
export function URLSearchMaker(params) {
    const us = new URLSearchParams(Object.entries(params));
    return us.toString();
}
/**
 * 对象值浅比对
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-06-30 10:21:58
 */
export function DiffObject(DiffObjectA, DiffObjectB) {
    const kvsA = Object.entries(DiffObjectA);
    const kvsB = Object.entries(DiffObjectB);
    return kvsA
        .map(([key, valueA]) => {
        const kvB = kvsB.find(([keyB]) => keyB === key);
        if (kvB === undefined) {
            return [];
        }
        const valueB = kvB[1];
        if (valueA === valueB) {
            return [];
        }
        else {
            return [
                {
                    [key]: valueB,
                },
            ];
        }
    })
        .flat();
}
export const datetimeFormat = new Intl.DateTimeFormat('zh-Hans-CN', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false,
});
export const customFormat = (acc, { type, value }) => {
    if (type === 'literal' && value === '/') {
        return `${acc}-`;
    }
    else if (/^\d$/.test(value)) {
        return `${acc}${value.padStart(2, '0')}`;
    }
    else {
        return `${acc}${value}`;
    }
};
/**
 * 柯里化的日期时间格式化函数
 * 接受三次传值
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-07-11 10:43:58
 * @param {number} timestamp 时间戳 --- 单位秒(从接口读取)，内部会转成毫秒
 * @param {Intl.DateTimeFormat} timestampFormatter Intl.DateTimeFormat 实例 --- 用于初步格式化时间戳并取得对应数据
 * @param {Function} customFormat 自定义格式化函数 --- 将前一个参数格式化之后获得的数据进行自定义的格式化用于拼接最终返回值
 */
export const formatDateTime = (timestamp) => (timestampFormatter) => (customFormat) => timestampFormatter.formatToParts(new Date(timestamp * 1000)).reduce(customFormat, '');
/**
 * 简化的formatDateTime
 * 直接屏蔽了细节，调用时只需要一个时间戳了
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-07-11 11:00:30
 */
export const shopFormatDateTime = (timestamp) => formatDateTime(timestamp)(datetimeFormat)(customFormat);
/**
 * 元转分
 * 分值需要提交存储
 * 额外处理精度问题
 * 临时解决方案，以后继续优化
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-06-27 23:50:19
 */
export const YuantoFen = (money) => parseInt((money * 100).toFixed(3));
//# sourceMappingURL=func.js.map